import { render, staticRenderFns } from "./JobClassIncome.vue?vue&type=template&id=29a3953b&scoped=true&"
import script from "./JobClassIncome.vue?vue&type=script&lang=js&"
export * from "./JobClassIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a3953b",
  null
  
)

export default component.exports